import { Component } from '@angular/core';
import { TwitterAccount } from './twitter-account.model';
import { RouterConst } from '../../../../globals/RoutersConst';
import { BreadcrumbService } from '../../../../breadcrumb.service';
import { ClientsService } from '../../../../services/clients/clients.service';
import { Globals } from '../../../../globals/Globals';
import { SuperClass } from '../../../../superclass/SuperClass';
import { DashboardDataService } from '../../../../services/dashboard-data.service';
import { WsService } from '../../../../services/websocket/WsService';
import { WsConst } from '../../../../globals/WsConst';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

@Component({
  selector: 'app-analytics-twitter-accounts',
  templateUrl: './twitter-accounts.component.html',
  styleUrls: ['./twitter-accounts.component.css'],
})
export class AnalyticsTwitterAccountsComponent extends SuperClass {
  accounts: TwitterAccount[];
  selectedRow: TwitterAccount;
  newAccount: TwitterAccount;
  newAccountForm: FormGroup;
  selectedRowForm: FormGroup;

  display = false;

  constructor(
    private breadcrumbService: BreadcrumbService,
    private dashboardDataService: DashboardDataService,
    private clientsService: ClientsService,
    private wsService: WsService,
    private httpClient: HttpClient,
    private cookiesService: CookieService,
    private fb: FormBuilder,
  ) {
    super(
      clientsService,
      wsService,
      dashboardDataService,
      httpClient,
      cookiesService,
    );

    this.reloadData();

    this.breadcrumbService.setItems([
      { label: 'Organization' },
      { label: 'Accounts' },
      {
        label: 'Twitter Accounts',
        routerLink: [
          { outlets: { sub: [RouterConst.ANALYTICS_TWITTER_ACCOUNTS] } },
        ],
      },
    ]);
    this.newAccount = new TwitterAccount();
  }

  reloadData() {
    this.http_getAllAccounts('twitter', (data: any) => {
      if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
        this.accounts = data.payload;
      }
    });

    this.selectedRowForm = this.fb.group({
      name: new FormControl('', Validators.required),
      appId: new FormControl('', Validators.required),
      secret: new FormControl('', Validators.required),
    });

    this.newAccountForm = this.fb.group({
      name: new FormControl('', Validators.required),
      appId: new FormControl('', Validators.required),
      secret: new FormControl('', Validators.required),
    });
  }

  selectRow(e) {
    this.selectedRow = new TwitterAccount(e.data);
  }

  saveAccount() {
    // const requiredFields = [
    //   {id: 'name', value: this.selectedRow.name, fieldName: 'Name'},
    //   {id: 'appId', value: this.selectedRow.appId, fieldName: 'App Id'}
    // ];
    // if (this.hasEmptyFields(requiredFields)) {
    //   return;
    // }

    this.http_updateAccounts(this.selectedRow, 'twitter', (data: any) => {
      this.showSuccessMessage('Account has been updated');
      this.unselectRow();
      this.accounts = data.payload;
    });
  }

  addNewAccount() {
    this.display = true;
    this.newAccount = new TwitterAccount();
  }

  createNewAccount() {
    // const requiredFields = [
    //   {id: 'new_name', value: this.newAccount.name, fieldName: 'Name'},
    //   {id: 'new_appId', value: this.newAccount.appId, fieldName: 'App Id'},
    //   {id: 'new_secret', value: this.newAccount.secret, fieldName: 'Secret'}
    // ];
    //
    // if (this.hasEmptyFields(requiredFields)) {
    //   return;
    // }

    this.http_addAccount(this.newAccount, 'twitter', (data: any) => {
      this.showSuccessMessage('Account has been created');
      this.unselectRow();
      this.accounts = data.payload;
    });
    this.display = false;
  }

  deleteAccount() {
    this.http_deleteAccount(this.selectedRow, 'twitter', (data: any) => {
      this.showSuccessMessage('Account has been deleted');
      this.unselectRow();
      this.accounts = data.payload;
    });
  }

  unselectRow() {
    this.selectedRow = undefined;
  }

  getWebSocketIdentifier(): string {
    return WsConst.TWITTER_ACCOUNTS;
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/accounts/twitter-accounts/twitter-accounts.component.ts